<template>
    <Modal small v-on="$listeners">
        <template slot="default">
            <SectionTitle :title="config.PROFILE_DELETE_TITLE"/>
            <SectionPicture>
                <ArtWarning :color="config.COLOR_WARNING"/>
            </SectionPicture>
            <SectionText :text="config.PROFILE_DELETE_DESCRIPTION"/>
        </template>
        <footer slot="footer">
            <button :color="config.COLOR_WARNING" :disabled="loading" outline @click="onCancel">
                {{ config.PROFILE_DELETE_CANCEL }}
            </button>
            <button :color="config.COLOR_WARNING" :disabled="loading" @click="onConfirm">
                {{ config.PROFILE_DELETE_CONFIRM }}
            </button>
        </footer>
    </Modal>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { SectionPicture, SectionTitle, SectionText } from '../../components/shared';

export default {
    name: 'ModalProfileDelete',
    components: { SectionPicture, SectionTitle, SectionText },
    mixins: [SolutionConsumer, UserConsumer],
    data () {
        return {
            loading: false,
        };
    },
    methods: {
        onCancel () {
            this.$emit('close');
        },
        async onConfirm () {
            try {
                this.loading = true;
                await this.deleteUser();
                await this.logout();
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';
@import '../../assets/scss/mixins';

footer {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    button {
        flex: 1;
        padding: 20px;
        outline: none;
        border: none;
        border-top: 1px solid $grey-lightest;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        background-color: inherit;
        color: $grey-darkest;
        transition: color .3s ease-in-out;

        &:disabled {
            color: $grey-lightest !important;
            pointer-events: none;
        }

        &:first-of-type {
            border-right: 1px solid $grey-lightest;
        }
    }
}
</style>
